<template>
  <div>
    <!-- Header -->
    <div class="header pb-6 pt-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center justify-content-lg-end">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-secondary">¡Bienvenido!</h1>
              <p class="text-lead text-secondary">Ingresa tus datos para iniciar sesión o crea un nuevo usuario.</p>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>-->
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center justify-content-lg-end">
        <div class="col-xl-5 col-lg-6 col-md-7">
          <div class="card bg-white border-0 mb-0">
            <div class="card-header bg-transparent">
              <div class="text-dark text-center">Ingresa a tu cuenta</div>
            </div>
            <div class="card-body px-lg-5 py-lg-5">
              <form role="form">
                <base-input
                            class="mb-3"
                            prepend-icon="fas fa-envelope"
                            placeholder="Email"
                            v-model="model.email">
                </base-input>

                <base-input
                            class="mb-3"
                            prepend-icon="fas fa-key"
                            type="password"
                            placeholder="Password"
                            v-model="model.password"
                            @keyup.enter="login()">
                </base-input>

                <base-checkbox v-model="model.rememberMe">Recúerdame</base-checkbox>
                <div class="text-center">
                  <base-button type="celcompink" class="my-4" block v-on:click="login()">Ingresar</base-button>
                </div>
              </form>

              <div class="row mt-3">
                <div class="col-6">
                  <router-link to="/dashboard" class="text-celcompink font-weight-600"><small>¿Olvidaste tu contraseña?</small></router-link>
                </div>
                <div class="col-6 text-right">
                  <router-link to="/register" class="text-celcompink font-weight-600"><small>Crear nueva cuenta</small></router-link>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import AES256 from 'aes-everywhere';
  import Vue from 'vue';
  import axios from 'axios';
  import VueAxios from 'vue-axios';
  import Config from '@/config/config.js';
  import { getUser, setUser, encryptAES, horaAhora,setUserAdmin, initPermisos,obtenerReporteEnvio } from '@/util/util.js';
  import moment from 'moment';
  import swal from 'sweetalert2';

  Vue.use(VueAxios, axios)

  export default {
    data() {
      return {
        model: {
          email: '',
          password: '',
          rememberMe: false
        },
      };
    },
    methods: {
        async login() {
          let self = this;

          this.$loading.show()   //delay default is 300ms

            if(this.model.email != "" && this.model.password != "") {

              let phoneUser=false;

              if(parseInt(this.model.email)){
                phoneUser=true;
              }


              ////////JSON LOGIN/////////
              var json_login = {
                "email": this.model.email,
                "password": this.model.password,
                "userPhone": phoneUser,
                "timeExpired": horaAhora(),
              }

              // encryption
              await Vue.axios.get(Config.url_service+Config.login+encodeURIComponent(encryptAES(json_login)))
              .then( async function (response) {
                  console.log(response)

                  if (response.data.response === "200") {

                    setUser(response.data.data.user);

                    setUserAdmin(response.data.data.customers)

                    localStorage.removeItem('user_sub');

                    await obtenerReporteEnvio();

                    await initPermisos()

                    self.$router.replace({ name: "Alternative" });

                  } else {
                    console.log("Usuario incorrecto");
                    swal({
                      title: 'Usuario incorrecto',
                      buttonsStyling: false,
                      confirmButtonClass: 'btn btn-danger',
                      type: 'error',
                    })
                  }

                  self.$loading.hide()


              })
              .catch(function (error) {
                  console.log("Error de servidor",error);
                  swal({
                    title: 'Error de servidor',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger',
                    type: 'error',
                  })

                  self.$loading.hide()
              });

            } else {

              swal({
                  title: 'Complete los campos requeridos',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })

                self.$loading.hide()

            }
        }
    }
  };
</script>
